import React from "react";
import { Form, Container, Row, Col } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "./UnifiedFormStyles.css";
import AppButton from "../../Components/MerchantButton";

function DefectiveTerminalDetails({
  defectiveDetails,
  setDefectiveDetails,
  defectiveError,
  setDefectiveError,
  handleDefectiveChange,
  navigation,
}) {
  // Validation logic for defective terminal details
  const validateDefectiveSection = () => {
    const errors = {
      defective_count: !defectiveDetails.defective_count,
      defective_id: !defectiveDetails.defective_id,
      defective_serial_nos: !defectiveDetails.defective_serial_nos
    };
    setDefectiveError(errors);

    const hasErrors = Object.values(errors).some(e => e);
    if (hasErrors) {
      toast.error("Please fill in all required fields", {
        autoClose: 3000,
        hideProgressBar: true,
        theme: "colored",
      });
      return false;
    }
    return true;
  };

  const handleNext = () => {
    if (validateDefectiveSection()) {
      navigation?.next();
    }
  };

  const handleBack = () => {
    navigation?.previous();
  };
  return (
    <div className="form-bg">
      <Container>
        <ToastContainer />
        <Row className="justify-content-md-center">

          {/* Main Form */}
          <Col md={10}>
              <div className="form-main-header">
                <h4 className="form-title">DEFECTIVE TERMINAL DETAILS</h4>
                <p className="form-desc">Please provide information about defective terminals</p>
              </div>
              <div className="form-main">
              <div className="form-main-content">
                <Form>
                  {/* Defective terminal count */}
                  <Form.Group className="mb-4" controlId="defective_count">
                    <Form.Label className="form-label">
                      Defective terminal count <span className="form-required">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="defective_count"
                      value={defectiveDetails.defective_count}
                      onChange={handleDefectiveChange}
                      placeholder="Ex. 1"
                      className={`form-input${defectiveError.defective_count ? " form-input-error" : ""}`}
                    />
                    {defectiveError.defective_count && (
                      <div className="form-error">
                        This field is required
                      </div>
                    )}
                  </Form.Group>

                  {/* Terminal ID of defective terminals */}
                  <Form.Group className="mb-4" controlId="defective_id">
                    <Form.Label className="form-label">
                      Terminal ID of defective terminals <span className="form-required">*</span>
                    </Form.Label>
                    <div >
                      <p className="form-note-text">
                       <em> For multiple terminals, use a comma to separate the Terminal IDs. (Ex. 20027409, 20029888) </em>
                      </p>
                    </div>
                    <Form.Control
                      type="text"
                      name="defective_id"
                      value={defectiveDetails.defective_id}
                      onChange={handleDefectiveChange}
                      placeholder="Enter terminal IDs..."
                      className={`form-input${defectiveError.defective_id ? " form-input-error" : ""}`}
                    />
                    {defectiveError.defective_id && (
                      <div className="form-error">
                        This field is required
                      </div>
                    )}
                  </Form.Group>
                  {/* Serial Nos. of defective terminals */}
                  <Form.Group className="mb-4" controlId="defective_serial_nos">
                    <Form.Label className="form-label">
                      Serial Nos. of defective terminals <span className="form-required">*</span>
                    </Form.Label>
                    <div>
                      <p className="form-note-text">
                      <em> S/N is located at the back of the terminal. For multiple terminals, use a comma to separate the Serial Nos. (Ex. 0821174246, 0823555592) </em>
                      </p>
                    </div>
                    <Form.Control
                      type="text"
                      name="defective_serial_nos"
                      value={defectiveDetails.defective_serial_nos}
                      onChange={handleDefectiveChange}
                      placeholder="Enter serial numbers..."
                      className={`form-input${defectiveError.defective_serial_nos ? " form-input-error" : ""}`}
                    />
                    {defectiveError.defective_serial_nos && (
                      <div className="form-error">
                        This field is required
                      </div>
                    )}
                  </Form.Group>
                  {/* Maya Terminal Escalation Case No. */}
                  <Form.Group className="mb-4" controlId="escalation_case_no">
                    <Form.Label className="form-label">
                      Maya Terminal Escalation Case No.
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="escalation_case_no"
                      value={defectiveDetails.escalation_case_no}
                      onChange={handleDefectiveChange}
                      placeholder="Enter escalation case number..."
                      className="form-input"
                    />
                  </Form.Group>

                  {/* Navigation Buttons */}
                  <div className="form-btn-row">
                    <AppButton
                      onClick={handleBack}
                      variant="back"
                      className="form-btn variant-secondary"
                    >
                      ← Back 
                    </AppButton>
                    <AppButton
                      onClick={handleNext}
                      variant="next"
                      className="form-btn variant-primary"
                    >
                     Next →
                    </AppButton>
                  </div>
              </Form>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  </div>
  );
}


export default DefectiveTerminalDetails;
